<template>
  <v-card-title>
    <v-container class="pa-12">
      <v-card class="pl-16 pr-16 pt-8 pb-16">
        <v-card-title>
          <v-row>
            <v-col cols="6" md="6" justify="center">
              <h3>New Document</h3>
            </v-col>
          </v-row>
        </v-card-title>

        <v-row class="row1 mt-3  pt-3 ">
          <v-col cols="12" md="8" offset="2">
            <v-text-field
              v-model="document_type"
              ref="myDocumentType"
              outlined
              dense
              label="Document Type"
              @blur="checkDocument()"
            ></v-text-field>
          </v-col>
        </v-row>
        <br />
        <div>
          <v-row>
            <v-col align="center" cols="12" md="12">
              <v-btn
                depressed
                width="100"
                class="mr-5 buttonblue"
                @click="saveItem()"
              >
                Save
              </v-btn>
              <v-btn depressed outlined width="100" @click="$router.back()">
                Cancel
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-card>
      <SuccessDialog
        :status="dialogAdd"
        :text_color="text_color"
        :title="title"
        :message="message"
      />

      <SuccessDialogPush
        :status="dialogAdd"
        :text_color="text_color"
        :title="title"
        :message="message"
        :link="link"
      />
    </v-container>
  </v-card-title>
</template>

<script>
import api from "@/services/api";
import { server } from "../services/constants";
import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import {
  tolocalestringnumber,
  stringcommatonumber,
} from "./computing/tolocalestringnumber";

export default {
  name: "NewAdvance",
  data() {
    return {
      document_type: "",
      dialogAdd: false,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
    };
  },
  components: {
    SuccessDialog,
    SuccessDialogPush,
  },
  computed: {},
  watch: {},
  async mounted() {
    const userId = localStorage.getItem(server.USER_ID);
    if (userId && api.isLoggedIn()) {
      // this.$router.push("/");
    } else {
      this.$store.state.isLogged = false;
      this.$router.push("/login");
    }
    this.$hideLoader();
  },
  methods: {
    async saveItem() {
      if (this.document_type == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check information",
          "Please Enter Document Type Data",
          "text-h5 red--text text-center"
        );
        this.$refs["myDocumentType"].focus();
        return;
      }
      await this.checkDocument();

      const additem = {
        doctype: this.document_type,
        department_authorization: "",
        user_create: localStorage.getItem(server.USER_ID),
      };
      this.$showLoader();
      const res_add = await api.createDoctype(additem);
      if (res_add.status == 200) {
        this.$hideLoader();
        this.$store.state.global_push_dialog = true;
        this.setupAlertDialogPush(
          true,
          "Information Saved",
          "Information successfully saved",
          "text-h5 green--text text-center",
          `/document-setup-edit/${res_add.data.id}`
        );
      } else {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Information Saved",
          "ไม่สามารถบันทึกได้",
          "text-h5 red--text text-center"
        );
      }
      // this.$router.push(`/document-setup-edit/${1}`);
    },
    async checkDocument() {
      if (this.document_type != "") {
        const res_check = await api.getCheckDoctype(this.document_type);
        if (res_check.data[0].status != 0) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Check information",
            "Duplicate Document Type, Please Enter New Document Type Data",
            "text-h5 red--text text-center"
          );
          this.$refs["myDocumentType"].focus();
          return;
        }
      }
    },
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
    setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },
  },
  async beforeCreate() {
    console.log("beforeCreate");
    this.$store.state.navMenu = true;
  },
};
</script>

<style scoped>
.center {
  text-align: center;
}
</style>
